import * as ReactRedux from 'react-redux';
import {
  getMembers,
  getMember,
  createMember,
  updateMember,
  bulkCancel,
  bulkAddDaysToEndDates,
  bulkSendEmail,
  bulkSendSms,
  createPayment,
  cancelMemberPayment,
  getAbsentMembers,
  exportCsv
} from './members.actions';
import MembersComponent from './MembersComponent';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { AppState } from '../app/app.types';
import { MemberType } from './members.types';
import { getPrograms } from '../programs/Actions';
import { Currency } from '../billing/billing.types';
import { getPackages } from '../mms-package/Actions';
import { getEmailTemplates } from 'src/emailTemplate/Actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    getMembers: () => dispatch(getMembers()),
    getMember: (memberId: number) => dispatch(getMember(memberId)),
    getAbsentMembers: (weeks: number) => dispatch(getAbsentMembers(weeks)),
    createMember: (
      file: File | null,
      firstName: string,
      lastName: string,
      initial: string,
      gender: string,
      birthDate: number,
      email: string,
      address: string,
      city: string,
      province: string,
      country: string,
      postalCode: string,
      mobile1: string,
      mobile2: string | undefined,
      startDate: number,
      endDate: number,
      emergencyContactName1: string | undefined,
      emergencyContactNumber1: string | undefined,
      emergencyContactName2: string | undefined,
      emergencyContactNumber2: string | undefined,
      emergencyContactName3: string | undefined,
      emergencyContactNumber3: string | undefined,
      checkinNotification: string,
      contractDuration: string,
      maxAttendancePerWeek: number,
      point: number,
      note: string,
      emailConsent: Boolean,
      smsConsent: Boolean,
      remainingClasses: number,
      memberType: MemberType,
      tags: string[]
    ) => dispatch(
      createMember(
        file,
        firstName,
        lastName,
        initial,
        gender,
        birthDate,
        email,
        address,
        city,
        province,
        country,
        postalCode,
        mobile1,
        mobile2,
        startDate,
        endDate,
        emergencyContactName1,
        emergencyContactNumber1,
        emergencyContactName2,
        emergencyContactNumber2,
        emergencyContactName3,
        emergencyContactNumber3,
        checkinNotification,
        contractDuration,
        maxAttendancePerWeek,
        point,
        note,
        emailConsent,
        smsConsent,
        remainingClasses,
        memberType,
        tags
      )
    ),
    updateMember: (
      id: number,
      file: File | null,
      firstName: string,
      lastName: string,
      initial: string,
      gender: string,
      birthDate: number,
      email: string,
      address: string,
      city: string,
      province: string,
      country: string,
      postalCode: string,
      mobile1: string,
      mobile2: string | undefined,
      startDate: number,
      endDate: number,
      emergencyContactName1: string | undefined,
      emergencyContactNumber1: string | undefined,
      emergencyContactName2: string | undefined,
      emergencyContactNumber2: string | undefined,
      emergencyContactName3: string | undefined,
      emergencyContactNumber3: string | undefined,
      checkinNotification: string,
      contractDuration: string,
      maxAttendancePerWeek: number,
      point: number,
      note: string,
      emailConsent: Boolean,
      smsConsent: Boolean,
      cancelled: boolean,
      remainingClasses: number,
      memberType: MemberType,
      tags: string[],
      cancelPayment: boolean,
      sendNotificationToMember: boolean
    ) => dispatch(
      updateMember(
        id,
        file,
        firstName,
        lastName,
        initial,
        gender,
        birthDate,
        email,
        address,
        city,
        province,
        country,
        postalCode,
        mobile1,
        mobile2,
        startDate,
        endDate,
        emergencyContactName1,
        emergencyContactNumber1,
        emergencyContactName2,
        emergencyContactNumber2,
        emergencyContactName3,
        emergencyContactNumber3,
        checkinNotification,
        contractDuration,
        maxAttendancePerWeek,
        point,
        note,
        emailConsent,
        smsConsent,
        cancelled,
        remainingClasses,
        memberType,
        tags,
        cancelPayment,
        sendNotificationToMember
      ),
    ),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toDashboard: () => dispatch(push(paths.dashboard)),
    toPaymentList: () => dispatch(push(paths.paymentList)),
    getPrograms: () => dispatch(getPrograms()),
    bulkCancel: (memberIds: number[], cancelMembership: boolean, cancelPayment: boolean) =>
      dispatch(bulkCancel(memberIds, cancelMembership, cancelPayment)),
    bulkAddDaysToEndDates: (memberIds: number[], days: number) => dispatch(bulkAddDaysToEndDates(memberIds, days)),
    bulkSendEmail: (memberIds: number[], emailTemplateId: number) =>
      dispatch(bulkSendEmail(memberIds, emailTemplateId)),
    bulkSendSms: (memberIds: number[], smsBody: string, sendMobile2: boolean) =>
      dispatch(bulkSendSms(memberIds, smsBody, sendMobile2)),
    createPayment: (
      id: number,
      paymentType: string,
      downPayment: number,
      total: number,
      amountPerTransaction: number,
      currency: Currency | '',
      term: string,
      numberOfTransactions: number,
      startDate: number,
      payerId: number,
      memberId: number,
      paymentMethodId: number,
      continuous: boolean,
      schedules: {
        scheduledPaymentId: number,
        chargeDate: number,
        amount: number,
        status: string
      }[],
      description?: string,
    ) => dispatch(createPayment(
      id,
      paymentType,
      downPayment,
      total,
      amountPerTransaction,
      currency,
      term,
      numberOfTransactions,
      startDate,
      payerId,
      memberId,
      paymentMethodId,
      continuous,
      schedules,
      description
    )),
    cancelMemberPayment: (paymentId: number) => dispatch(cancelMemberPayment(paymentId)),
    getPackages: () => dispatch(getPackages()),
    getEmailTemplates: () => dispatch(getEmailTemplates()),
    exportCsv: (memberIds: number[]) => dispatch(exportCsv(memberIds))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    idleState: state.idleState,
    businessState: state.businessState,
    packageState: state.packageState,
    membersState: state.membersState,
    programsState: state.programsState,
    emailTemplateState: state.emailTemplateState
  };
};

const Members = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(MembersComponent);

export default Members;



// WEBPACK FOOTER //
// ./src/members/Members.tsx